export const ENGINE_UPLOAD_SECRET_KEY_REQUEST = 'ENGINE_UPLOAD_SECRET_KEY_REQUEST'
export const ENGINE_UPLOAD_SECRET_KEY_SUCCESS = 'ENGINE_UPLOAD_SECRET_KEY_SUCCESS'
export const ENGINE_UPLOAD_SECRET_KEY_FAILURE = 'ENGINE_UPLOAD_SECRET_KEY_FAILURE'

export const ENGINE_PREPARE_REQUEST = 'ENGINE_PREPARE_REQUEST'
export const ENGINE_PREPARE_SUCCESS = 'ENGINE_PREPARE_SUCCESS'
export const ENGINE_PREPARE_FAILURE = 'ENGINE_PREPARE_FAILURE'

export const ENGINE_COMPUTE_REQUEST = 'ENGINE_COMPUTE_REQUEST'
export const ENGINE_COMPUTE_SUCCESS = 'ENGINE_COMPUTE_SUCCESS'
export const ENGINE_COMPUTE_FAILURE = 'ENGINE_COMPUTE_FAILURE'

export const ENGINE_RESPONSE_REQUEST = 'ENGINE_RESPONSE_REQUEST'
export const ENGINE_RESPONSE_SUCCESS = 'ENGINE_RESPONSE_SUCCESS'
export const ENGINE_RESPONSE_FAILURE = 'ENGINE_RESPONSE_FAILURE'
